// extracted by mini-css-extract-plugin
export default {"container":"header_container__wJ123","firstPart":"header_firstPart__CLwlp","secondPart":"header_secondPart__xFPYy"};